import React, {useEffect, useState, useContext} from 'react'
import {useAuth} from '../../modules/auth'

import {changeTextCapital, getPaginationInfoData, checkRole} from '../../../_metronic/helpers'
import {Center, Loader, Pagination, SelectItem, Text} from '@mantine/core'
import Button from '../../components/Button/Button'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {ToastContainer} from 'react-toastify'
import {getLeaveTypeData, getRecords, getUserData, getTeamMemberData} from '../../CommonFunction'
import API from '../../../api/APIUrl'
import {APIStatusData} from '../../data/OtherDefaultData'
import {APIStatusType, RoleContextValue} from '../../types/OtherTypes'
import Select2 from '../../components/select2'
import roleContext from '../../context/roleContext'

export interface UserLeaveBalanceData extends APIStatusType {
  data: {
    items: {
      userId: string
      name: string
      email: string
      leaveTypes: {
        leaveTypeId: string
        leaveTypeName: string
        credited: number
        used: number
        remaining: number
      }[]
    }[]

    limit: number
    page: number
    total: number
  }
}

const LeaveAccount = ({getLeaveBalances, setBalance}) => {
  const {currentUser} = useAuth()
  let roleState: RoleContextValue = useContext(roleContext)
  const [activePage, setActivePage] = useState(1)
  const [leaveBalance, setLeaveBalance] = useState<UserLeaveBalanceData>({
    ...APIStatusData,
    data: {items: [], limit: 10, page: 1, total: 0},
  })
  const [formField, setFormField] = useState<{userId: string}>({
    userId: 'all',
  })
  const [user, setUser] = useState<SelectItem[]>([])
  const [leaveType, setLeaveType] = useState<SelectItem[]>([])
  const [searchText, setSearchText] = useState('')

  // Check if user can see all employees - ONLY Super Admin can see all users
  const canSeeAllEmployees = roleState.features.includes('super admin')
  
  // Check if user is RM/HR and can see their team (Admin is now treated like RM/HR)
  const canSeeTeamMembers = currentUser?.isRmOrHr || 
                           roleState.features.includes('admin')
  
  // Check if user dropdown should be visible
  // Show dropdown only if:
  // 1. User is Super Admin (can see all users), OR
  // 2. User is Admin/RM/HR AND has team members to manage (user list > 1, meaning self + others)
  const shouldShowUserDropdown = canSeeAllEmployees || (canSeeTeamMembers && user.length > 1)

  // Debug logging removed

  // Helper function to build consistent API URLs
  const buildApiUrl = (page: number, userId: string = formField.userId) => {
    const baseUrl = `${API.LEAVEBALANCE}/audit`;
    // Always pass the current user's ID for backend permission checking
    let apiUrl = `${baseUrl}?page=${page}&userId=${currentUser?.id}`;
    
    if (userId !== 'all' && userId) {
      const selectedUser = user?.find((item) => item?.value === userId);
      if (selectedUser) {
        apiUrl += `&search=${selectedUser.label}`;
      }
    }
    
    return apiUrl;
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getLeaveTypeData(setLeaveType)
      
      // Only load leave balance data if we have currentUser.id (needed for backend permission checking)
      if (currentUser?.id) {
        const apiUrl = `${API.LEAVEBALANCE}/audit?page=1&userId=${currentUser.id}`;
        getRecords(apiUrl, setLeaveBalance);
      }
      
      // Fetch users based on role permissions
      if (canSeeAllEmployees) {
        // Super Admin can see all users
        getUserData(setUser)
      } else if (canSeeTeamMembers && currentUser?.id) {
        // Admin/RM/HR can see their team members
        getTeamMemberData(setUser, currentUser.id)
      } else {
        // Regular users don't need user dropdown - they can only see themselves
        setUser([])
      }
      // getallUsersLeave(setUserBalance, setAPIStatus)
    }
    return () => {
      mounted = false
    }
  }, [canSeeAllEmployees, canSeeTeamMembers, currentUser?.id])
  useEffect(() => {
  if (!currentUser?.id) return
    const timeout = setTimeout(() => {
      let apiUrl = `${API.LEAVEBALANCE}/audit?page=1&userId=${currentUser.id}`
      if (searchText.trim()) {
        apiUrl += `&search=${searchText}`
      }
      setActivePage(1)
      getRecords(apiUrl, setLeaveBalance)
    }, 500)
    return () => clearTimeout(timeout)
  }, [searchText, currentUser?.id])
  return (
    <>
      {/* <Modal
        show={reasonModalOpen}
        onClose={() => setReasonModalOpen(false)}
        animation={false}
        backdrop='static'
        centered
      >
        <div className='card'>
          <div className='modal-header '>
            <h2 className='fw-bolder'>Add Leave</h2>
            <div
              className='btn btn-icon btn-sm btn-active-icon-danger'
              data-kt-users-modal-action='close'
              style={{cursor: 'pointer'}}
              onClick={() => {
                setReasonModalOpen(false)
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
              }}
            >
              <i className='fa-solid fa-xmark fs-1' />
            </div>
          </div>

          <div className='card-body'>
            <div className='fv-row mb-5 col-md-12'>
              <label className='required fs-6 fw-semibold mb-2'> Subject</label>
              <Select2
                name='leaveType'
                data={[
                  {label: 'Optional Leave', value: 'Optional Leave'},
                  {label: 'Paid', value: 'Paid'},
                  {label: 'Short Leave', value: 'Short Leave'},
                  {label: 'Unpaid', value: 'Unpaid'},
                  {label: 'Work From Home', value: 'Work From Home'},
                ]}
                value={inputField.leaveType}
                placeholder='Subject'
                onChange={(selectedOption: any) => {
                  setInputField((prevInputField) => ({
                    ...prevInputField,
                    leaveType: selectedOption,
                  }))
                }}
              />
              <InputErrorBox Message={inputError.leaveType} />
            </div>

            <div className='row'>
              <div className='fv-row mb-5 col-md-6'>
                <label className='required fs-6 fw-semibold mb-2'> Start Date</label>
                <input
                  className='form-control mt-2'
                  type='date'
                  value={inputField.leaveDate.startDate}
                  name='startDate'
                  onChange={(event) =>
                    handleInputChanges(event, 'leaveDate', setInputField, inputField)
                  }
                />
                <InputErrorBox Message={inputError.startDate} />
              </div>

              <div className='fv-row mb-5 col-md-6'>
                <label className='required fs-6 fw-semibold mb-2'> End Date</label>
                <input
                  className='form-control mt-2'
                  type='date'
                  value={inputField.leaveDate.endDate}
                  name='endDate'
                  onChange={(event) =>
                    handleInputChanges(event, 'leaveDate', setInputField, inputField)
                  }
                />
                <InputErrorBox Message={inputError.endDate} />
              </div>
            </div>

            <div className=''>
              <div className='fv-row me-1 mb-2 '>
                <label className='required fw-bold fs-6 mb-2'>Type</label>
                <div className='d-flex mt-3'>
                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='radio'
                      id='full'
                      name='type'
                      value='full'
                      checked={inputField.leaveDate.type === 'full'}
                      onChange={(event) =>
                        handleInputChanges(event, 'leaveDate', setInputField, inputField)
                      }
                    />

                    <label htmlFor='full' className='fw-bold text-gray-800 d-block me-3'>
                      Full
                    </label>
                  </div>

                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='type'
                      value='firstHalf'
                      checked={inputField.leaveDate.type === 'firstHalf'}
                      onChange={(event) =>
                        handleInputChanges(event, 'leaveDate', setInputField, inputField)
                      }
                    />
                    <label htmlFor='firstHalf' className=' fw-bold text-gray-800 d-block me-3'>
                      First Half
                    </label>
                  </div>

                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='type'
                      value='secondHalf'
                      checked={inputField.leaveDate.type === 'secondHalf'}
                      onChange={(event) =>
                        handleInputChanges(event, 'leaveDate', setInputField, inputField)
                      }
                    />
                    <label htmlFor='secondHalf' className=' fw-bold text-gray-800 d-block'>
                      Second Half
                    </label>
                  </div>
                </div>
              </div>
              <InputErrorBox Message={inputError.type} />
            </div>
          </div>

          <div className='card-footer d-flex justify-content-end'>
            <Button
              variant='secondary'
              size='sm'
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
              }}
              type='button'
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              size='sm'
              onClick={() => {
                addManualLeaves(
                  inputField,
                  currentUser,
                  setUserBalance,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  setAPIStatus,
                  setInputError,
                  validateFormFields,
                  setReasonModalOpen,
                  fetchData
                )
              }}
              type='button'
            >
              Save
            </Button>
          </div>
        </div>
      </Modal> */}

      <div className='card mb-4' style={{borderRadius: '12px', border: '1px solid rgb(226, 236, 247)', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 3px', backgroundColor: 'rgb(255, 255, 255)'}}>
        <div className='card-header d-flex justify-content-between align-items-center' style={{backgroundColor: 'rgb(255, 255, 255)', borderBottom: '1px solid rgb(226, 236, 247)', padding: '12px 16px'}}>
          <h5 className='card-title mb-0' style={{color: 'rgb(18, 59, 115)', fontWeight: '600', fontSize: '14px'}}>Leave Account</h5>
          <div className="position-relative">
            <input
              type="text"
              className="form-control"
              placeholder="Search User Name..."
              style={{ 
                width: '250px',
                borderRadius: '8px',
                border: '1px solid rgb(226, 236, 247)',
                padding: '8px 36px 8px 12px',
                fontSize: '12px',
                backgroundColor: 'rgb(248, 250, 252)'
              }}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <i 
              className="fa fa-search" 
              style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'rgb(148, 163, 184)',
                fontSize: '12px'
              }}
            ></i>
            {searchText && (
              <span
                onClick={() => setSearchText('')}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  fontSize: '14px',
                  color: 'rgb(148, 163, 184)',
                  fontWeight: 'bold'
                }}
              >
                ✕
              </span>
            )}
          </div>
        </div>

        <div className='card-body' style={{padding: '0px'}}>
          {leaveBalance.loading ? (
            <Center style={{padding: '80px 24px'}}>
              <Loader />
            </Center>
          ) : (
            <>
              <div style={{overflowX: 'auto', maxWidth: '100%'}}>
                <table style={{width: '100%', minWidth: '800px', tableLayout: 'fixed', borderCollapse: 'collapse', backgroundColor: 'rgb(255, 255, 255)'}}>
                  <thead>
                    <tr style={{backgroundColor: 'rgb(244, 248, 253)'}}>
                      <th style={{padding: '12px 16px', textAlign: 'left', color: 'rgb(18, 59, 115)', fontWeight: '600', fontSize: '12px', borderBottom: '1px solid rgb(226, 236, 247)', whiteSpace: 'nowrap', width: '25%'}}>User Name</th>
                      {leaveType?.map((obj) => (
                        <th key={obj?.value} style={{padding: '12px 16px', textAlign: 'center', color: 'rgb(18, 59, 115)', fontWeight: '600', fontSize: '12px', borderBottom: '1px solid rgb(226, 236, 247)', whiteSpace: 'nowrap', width: '15%'}}>{obj?.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {leaveBalance?.data?.items
                      ?.filter((obj) =>
                        obj?.name?.toLowerCase().includes(searchText.toLowerCase())
                      )
                      ?.length > 0 ? (
                      leaveBalance?.data?.items
                        ?.filter((obj) =>
                          obj?.name?.toLowerCase().includes(searchText.toLowerCase())
                        )
                        .map((obj) => (
                          <tr key={obj?.userId ?? '-'} style={{borderBottom: '1px solid rgb(226, 236, 247)', transition: 'background-color 0.2s', backgroundColor: 'transparent'}}>
                            <td style={{padding: '12px 16px', verticalAlign: 'middle'}}>
                              <div style={{color: 'rgb(18, 59, 115)', fontWeight: '600', fontSize: '12px', marginBottom: '4px'}}>
                                {obj?.name}
                              </div>
                              <a
                                style={{color: 'rgb(59, 130, 246)', fontSize: '11px', textDecoration: 'none'}}
                                href={`mailto:${obj?.email}`}
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                {obj?.email}
                              </a>
                            </td>

                            {leaveType?.map((leaveType) => (
                              <td
                                key={leaveType?.value}
                                style={{padding: '12px 16px', verticalAlign: 'middle', textAlign: 'center'}}
                              >
                                {obj?.leaveTypes?.filter(
                                  (item) => item?.leaveTypeId == leaveType?.value
                                )?.length > 0 ? (
                                  <span
                                    style={{
                                      backgroundColor: 'rgb(234, 244, 255)',
                                      color: 'rgb(59, 130, 246)',
                                      padding: '6px 12px',
                                      borderRadius: '12px',
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      display: 'inline-block',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    {
                                      obj?.leaveTypes?.filter(
                                        (item) => item?.leaveTypeId == leaveType?.value
                                      )[0]?.used
                                    }
                                    /{' '}
                                    {
                                      obj?.leaveTypes?.filter(
                                        (item) => item?.leaveTypeId == leaveType?.value
                                      )[0]?.credited
                                    }
                                  </span>
                                ) : (
                                  <span style={{color: 'rgb(148, 163, 184)', fontSize: '12px'}}>-</span>
                                )}
                              </td>
                            ))}
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan={leaveType?.length + 1} style={{padding: '80px 24px', textAlign: 'center'}}>
                          <div style={{backgroundColor: 'rgb(244, 248, 253)', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0px auto 20px'}}>
                            <i className='fa fa-user-clock fa-2x' style={{color: 'rgb(100, 116, 139)', fontSize: '32px'}}></i>
                          </div>
                          <div style={{color: 'rgb(18, 59, 115)', fontSize: '18px', fontWeight: '600', marginBottom: '8px'}}>No leave accounts found</div>
                          <div style={{color: 'rgb(100, 116, 139)', fontSize: '14px'}}>Try adjusting your search</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className='d-flex mt-4' style={{padding: '12px 16px', borderTop: '1px solid rgb(226, 236, 247)', backgroundColor: 'rgb(255, 255, 255)'}}>
                <Text className='me-auto' style={{color: 'rgb(100, 116, 139)', fontSize: '11px'}}>
                  {getPaginationInfoData(
                    activePage,
                    '10',
                    leaveBalance?.data?.total?.toString() ?? '',
                    {
                      data: leaveBalance?.data?.items ?? '',
                    }
                  )}{' '}
                  Of {Math.ceil(Number(leaveBalance?.data?.total ?? 0))}
                </Text>
                <Pagination
                  value={activePage}
                  size='sm'
                  styles={(theme) => ({
                    control: {
                      '&[data-active]': {
                        backgroundColor: 'rgb(59, 130, 246)',
                        color: 'white',
                        border: 'none',
                      },
                      '&:hover:not([data-disabled])': {
                        backgroundColor: 'rgb(234, 244, 255)',
                        color: 'rgb(59, 130, 246)',
                      },
                    },
                  })}
                  onChange={(page) => {
                    setActivePage(page)
                    getRecords(buildApiUrl(page), setLeaveBalance)
                  }}
                  total={Math.ceil(Number(leaveBalance?.data?.total ?? 0) / Number(10))}
                ></Pagination>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default LeaveAccount
